import { remplazarPorTildeASinTilde, filter } from "../../../helpers/Buscador";
import { types } from "../../../types/types";

const initialState = {
  items: [],
  itemsAux: [],
  loading: false,
};

export const abmMotivosBajaEfectorReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.abmTraerMotivosBajaSuccess:
          return {
            ...state,
            loading: false,
            items: action.payload,
            itemsAux: action.payload
          };
        case types.abmBuscarMotivosBaja:
          var itemsResults = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(action.payload)))
          return {
            ...state,
            items: itemsResults
          }; 
        default:
          return state;
      }
};
